import createIcon from '../../createIcon';

/**
 * @component @name DirectionsWalk
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNS4yNUMxNC4xIDUuMjUgMTUgNC4zNSAxNSAzLjI1QzE1IDIuMTUgMTQuMSAxLjI1IDEzIDEuMjVDMTEuOSAxLjI1IDExIDIuMTUgMTEgMy4yNUMxMSA0LjM1IDExLjkgNS4yNSAxMyA1LjI1Wk05LjMgOC42NUw2LjUgMjIuNzVIOC42TDEwLjQgMTQuNzVMMTIuNSAxNi43NVYyMi43NUgxNC41VjE1LjI1TDEyLjQgMTMuMjVMMTMgMTAuMjVDMTQuMyAxMS43NSAxNi4zIDEyLjc1IDE4LjUgMTIuNzVWMTAuNzVDMTYuNiAxMC43NSAxNSA5Ljc1IDE0LjIgOC4zNUwxMy4yIDYuNzVDMTIuOCA2LjE1IDEyLjIgNS43NSAxMS41IDUuNzVDMTEuMiA1Ljc1IDExIDUuODUgMTAuNyA1Ljg1TDUuNSA4LjA1VjEyLjc1SDcuNVY5LjM1TDkuMyA4LjY1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsWalk = createIcon('DirectionsWalk', [
  [
    'path',
    {
      d: 'M13 5.25C14.1 5.25 15 4.35 15 3.25C15 2.15 14.1 1.25 13 1.25C11.9 1.25 11 2.15 11 3.25C11 4.35 11.9 5.25 13 5.25ZM9.3 8.65L6.5 22.75H8.6L10.4 14.75L12.5 16.75V22.75H14.5V15.25L12.4 13.25L13 10.25C14.3 11.75 16.3 12.75 18.5 12.75V10.75C16.6 10.75 15 9.75 14.2 8.35L13.2 6.75C12.8 6.15 12.2 5.75 11.5 5.75C11.2 5.75 11 5.85 10.7 5.85L5.5 8.05V12.75H7.5V9.35L9.3 8.65Z',
      key: '118vzt',
    },
  ],
]);

export default DirectionsWalk;
